import { render, staticRenderFns } from "./ReferenceInformationDialog.vue?vue&type=template&id=1e357236&"
import script from "./ReferenceInformationDialog.vue?vue&type=script&lang=js&"
export * from "./ReferenceInformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports